// extracted by mini-css-extract-plugin
export default {"credit":"ImageCredit_credit__Hc+4k"};